module.exports = __webpack_public_path__ + "static/icecream200_1-d4b3f2522861b5c6bed7a95134dafbaa.png";